import { Config } from '@modernanimal/common';
import { initializeApolloClient } from '@modernanimal/common/src/api';

// Shared Apollo client for the onboarding experience
const apiRoot = process.env.REACT_APP_LOCAL_SERVER ? 'http://localhost:8000/' : Config.ApiRoot;

const apolloClient = initializeApolloClient('public', apiRoot, null, 'standard');

export default apolloClient;
